package com.milta.feature.delivery.data.remote

import com.milta.core.network.ApiException
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.delivery.data.dto.AddressSuggestionResponse
import com.milta.feature.delivery.data.dto.CreateDeliveryRequest
import com.milta.feature.delivery.data.dto.DeliveryResponse
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess

class DeliveryApi(private val client: HttpClient) {

    suspend fun createDelivery(routeId: String, request: CreateDeliveryRequest): DeliveryResponse {
        val response = client.post("$baseUrl/${Endpoints.routeManualDelivery(routeId)}") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    /** GET api/v1/addresses/autocomplete — suggestions as the caller types (manual entry screens).
     * [language] (BCP-47, e.g. "fr") is forwarded as Nominatim's accept-language hint so
     * display_name comes back in one language instead of Nominatim's default bilingual
     * concatenation in mixed-language areas (e.g. Brussels) — omitted when null/unrecognized. */
    suspend fun autocompleteAddress(query: String, language: String?): List<AddressSuggestionResponse> =
        client.get("$baseUrl/${Endpoints.addressAutocomplete}") {
            parameter("query", query)
            if (language != null) parameter("language", language)
        }.decodeOrThrow()

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${status.value}"
            throw ApiException(status.value, message)
        }
        return body()
    }
}
